module.exports = __webpack_public_path__ + "static/Dropshadow-SW-d3bdf110ae80769871a78abe663b6399.png";